/**
 * SerieDeleteDialog - Componente extraído do AgendamentosPage
 * Gerencia exclusão de agendamentos em série (recorrentes)
 * 
 * FASE 1 da refatoração - Extração de diálogos isolados
 */
import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '../../components/ui/alert-dialog';
import { Button } from '../../components/ui/button';
import { Loader2 } from 'lucide-react';

// Estado inicial do dialog
export const initialSerieDeleteState = {
  open: false,
  agendamento: null,
  serieInfo: null,
  loading: false
};

/**
 * SerieDeleteDialog Component
 * 
 * @param {Object} props
 * @param {Object} props.dialogState - Estado do dialog
 * @param {Function} props.setDialogState - Setter do estado do dialog
 * @param {Function} props.onDeleteSingle - Callback para excluir apenas este evento
 * @param {Function} props.onDeleteSerie - Callback para excluir toda a série
 */
const SerieDeleteDialog = ({
  dialogState,
  setDialogState,
  onDeleteSingle,
  onDeleteSerie
}) => {
  
  const handleClose = () => {
    if (dialogState.loading) return;
    setDialogState(initialSerieDeleteState);
  };

  return (
    <AlertDialog 
      open={dialogState.open} 
      onOpenChange={(open) => !dialogState.loading && setDialogState(prev => ({ ...prev, open }))}
    >
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle style={{ fontFamily: 'Manrope, sans-serif', color: '#2C3632' }}>
            Excluir Agendamento Recorrente
          </AlertDialogTitle>
          <AlertDialogDescription className="space-y-2">
            <p>
              Este agendamento faz parte de uma <strong>série recorrente</strong> com{' '}
              <strong>{dialogState.serieInfo?.agendamentos_futuros || 0}</strong> evento(s) futuro(s).
            </p>
            <p>O que deseja fazer?</p>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter className="flex-col sm:flex-row gap-2">
          <AlertDialogCancel 
            disabled={dialogState.loading}
            onClick={handleClose}
          >
            Cancelar
          </AlertDialogCancel>
          <Button
            variant="outline"
            disabled={dialogState.loading}
            onClick={() => onDeleteSingle(dialogState.agendamento)}
            className="border-amber-500 text-amber-600 hover:bg-amber-50"
            data-testid="btn-delete-single"
          >
            {dialogState.loading ? <Loader2 className="h-4 w-4 animate-spin mr-2" /> : null}
            Apenas Este Evento
          </Button>
          <Button
            disabled={dialogState.loading}
            onClick={() => onDeleteSerie(dialogState.agendamento)}
            className="bg-red-600 hover:bg-red-700 text-white"
            data-testid="btn-delete-serie"
          >
            {dialogState.loading ? <Loader2 className="h-4 w-4 animate-spin mr-2" /> : null}
            Toda a Série ({dialogState.serieInfo?.agendamentos_futuros || 0})
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default SerieDeleteDialog;
